<template>
  <div class="modal">
    <div class="modal_inner">
      <div class="nav basic">
        <div class="title">
          <h4 v-html="title"></h4>
        </div>
        <button
          type="button"
          class="modal_close"
          @click="$emit('closeBusSeat')"
        ></button>
      </div>
      <slot name="modalContent"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseModal",
  props: {
    title: {
      type: [String, HTMLAllCollection],
    },
    modalState: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
